module.exports = __webpack_public_path__ + "assets/img/chrome.ac630da8.svg";